import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import styleSelectedText from 'flarum/common/utils/styleSelectedText';
import { COLORS, DEFAULT_COLOR } from '../colors';
const t = key => app.translator.trans('ppk2-format.forum.composer.' + key);

/**
 * Composer toolbar: highlighter button. Click → a small palette of 9 colours;
 * a colour wraps the selected text in [mark=…]…[/mark] (yellow → plain [mark]).
 */
export default class MarkButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.open = false;
    this.outside = e => {
      if (this.open && this.element && !this.element.contains(e.target)) {
        this.open = false;
        m.redraw();
      }
    };
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    document.addEventListener('mousedown', this.outside);
  }
  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('mousedown', this.outside);
  }
  view() {
    const button = m("button", {
      className: 'Button Button--icon Button--link Ppk2MarkButton-toggle' + (this.open ? ' active' : ''),
      type: "button",
      "aria-label": t('mark_tooltip'),
      "aria-expanded": this.open ? 'true' : 'false',
      onclick: () => this.toggle()
    }, m(Icon, {
      name: "fas fa-highlighter"
    }));
    return m("span", {
      className: "Ppk2MarkButton"
    }, this.open ? button : m(Tooltip, {
      text: String(t('mark_tooltip'))
    }, button), this.open && m("div", {
      className: "Ppk2MarkButton-palette",
      role: "menu",
      style: this.pos
    }, COLORS.map(c => m("button", {
      type: "button",
      role: "menuitem",
      className: 'ppk2-mark ppk2-mark--' + c + ' Ppk2MarkButton-swatch',
      title: String(t('color_' + c)),
      onclick: () => this.apply(c)
    }, t('color_' + c)))));
  }

  // The composer toolbar scrolls horizontally (overflow), so the palette is placed with
  // position: fixed next to the button instead of inside the toolbar box.
  toggle() {
    this.open = !this.open;
    if (this.open && this.element) {
      const r = this.element.getBoundingClientRect();
      const w = Math.min(260, window.innerWidth - 16);
      const left = Math.max(8, Math.min(r.right - w, window.innerWidth - w - 8));
      this.pos = {
        left: left + 'px',
        bottom: window.innerHeight - r.top + 6 + 'px',
        width: w + 'px'
      };
    }
  }
  apply(color) {
    this.open = false;
    const prefix = color === DEFAULT_COLOR ? '[mark]' : '[mark=' + color + ']';
    const suffix = '[/mark]';
    const editor = this.attrs.editor;
    const el = editor && editor.el;
    if (el && el.tagName === 'TEXTAREA') {
      styleSelectedText(el, {
        prefix,
        suffix,
        trimFirst: true
      });
    } else if (editor && editor.insertAtCursor) {
      editor.insertAtCursor(prefix + suffix);
    }
  }
}
flarum.reg.add('ppk2-format', 'forum/components/MarkButton', MarkButton);